import React, { useState } from "react";
import { Star } from "lucide-react";
import { useT } from "../../lib/LanguageContext";
import { REVIEWS } from "../../constants/testIds/reviews";
import ModerationTable from "./ModerationTable";
import ReviewProgramForm from "./ReviewProgramForm";

const TABS = [
  { key: "reviews", labelKey: "srev.tab.reviews", testId: REVIEWS.saTabReviews },
  { key: "settings", labelKey: "srev.tab.settings", testId: REVIEWS.saTabSettings },
];

/**
 * The platform operator's review console: the moderation queue, and the program itself.
 *
 * TWO TABS, TWO PERMISSIONS. Reading and hiding are `tenants.read` / `tenants.write` — they
 * are decisions about a practice's public record. The program is `settings.write`, because
 * `started_at` and `enabled` govern the whole platform's minting. Nothing here is step-up
 * gated: no money moves, and a step-up on a moderation queue would only train an operator
 * to click through one.
 *
 * MODERATION IS THE OPERATOR'S ALONE (decision D2). The practice may reply once and flag
 * once; only this console can hide. That is what makes the ranking something the ranked
 * cannot curate.
 */
export default function ReviewsModeration() {
  const t = useT("superadmin");
  const [tab, setTab] = useState("reviews");

  return (
    <div data-testid={REVIEWS.saPage} className="text-slate-800 space-y-6">
      <div>
        <h1 className="text-3xl flex items-center gap-3">
          <Star className="w-6 h-6 text-sol-gold" /> {t("srev.title")}
        </h1>
        <p className="text-sm text-slate-400 mt-1">{t("srev.subtitle")}</p>
      </div>

      <div className="flex gap-1 flex-wrap border-b border-slate-200" role="tablist">
        {TABS.map((tb) => (
          <button
            key={tb.key}
            type="button"
            role="tab"
            aria-selected={tab === tb.key}
            onClick={() => setTab(tb.key)}
            data-testid={tb.testId}
            className={`px-4 py-2 text-sm rounded-t-lg ${
              tab === tb.key ? "bg-white border border-b-white border-slate-200 text-slate-900" : "text-slate-500"
            }`}
          >
            {t(tb.labelKey)}
          </button>
        ))}
      </div>

      {tab === "reviews" && <ModerationTable />}
      {tab === "settings" && <ReviewProgramForm />}
    </div>
  );
}
